import { getSetup } from './getSetup';
import { fetchAccessToken } from './fetchAccessToken';

export default async function fetchContentByHash(uid: string): Promise<any> {
    const setup = getSetup();

    const url =
        localStorage.getItem('use_qs') === 'true'
            ? setup.market.qsUrl
            : setup.market?.prodUrl;
    try {
        const expiresAt = localStorage.getItem('accesstoken_expires_at');
        const isExpired = !expiresAt || Date.now() > Number(expiresAt);

        const accessToken =
            navigator.onLine && isExpired
                ? await fetchAccessToken()
                : localStorage.getItem('accesstoken');
        const resp = await fetch(
            `${url}/module/delivery/bpca/api/v2/contents?fields-preset=full`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Cache-Control': 'max-age=0',
                },
            }
        );

        if (!resp.ok) {
            console.error(`Fetch failed with status: ${resp.status}`);
            return undefined;
        }
        const data = await resp.json();
        if (!data?.Contents || !Array.isArray(data.Contents)) return undefined;
        const project = data.Contents.find((e: any) => e.Uid === uid);
        if (!project) return undefined;
        return project;
    } catch {
        return undefined;
    }
}
